import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{
  fullWidth: boolean;
  mode: 'light' | 'dark';
}>()((theme, { fullWidth, mode }) => ({
  root: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    width: fullWidth ? '100%' : 'auto',
    '&:hover .MuiInputBase-root:not(.Mui-disabled) #close-icon': {
      visibility: 'visible',
    },

    '& label': {
      fontSize: '1rem',
    },
    '& .MuiOutlinedInput-root': {
      minHeight: '44px',
      backgroundColor:
        mode === 'light' ? theme.palette.input.main : theme.palette.input.dark,
      color: theme.palette.input.contrastText,
      '& fieldset': {
        borderColor: theme.palette.input.dark,
      },
      '&:not(.Mui-disabled):hover fieldset': {
        borderColor: theme.palette.input.dark,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-disabled': {
        backgroundColor: theme.palette.input.disabled,
      },
      '& input[type=number]': {
        MozAppearance: 'textfield',
        WebkitAppearance: 'none',
      },
      '& input::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '& input::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
    },
    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.input.placeholderText,
      opacity: 1,
    },

    '&:hover .Mui-error fieldset': {
      borderColor: `${theme.palette.error.main} !important`,
    },
  },
  label: {
    color: theme.palette.font.secondary,
    lineHeight: 1,
    position: 'static',
    transform: 'none',
    transformOrigin: 'left top',
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(2),
    '&.Mui-disabled': {
      color: theme.palette.font.disabled,
      opacity: 1,
    },
  },

  viewModeWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },

  closeIcon: {
    color: theme.palette.text.primary,
    height: 12,
    visibility: 'hidden',
    width: 12,
    '&:hover': {
      cursor: 'pointer',
    },
  },

  toolTip: {
    '& .MuiTooltip-tooltip': {
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.grey[300]}`,
      boxSizing: 'border-box',
      borderRadius: theme.spacing(0.75),
      color: theme.palette.text.primary,
      padding: theme.spacing(2),
    },
  },
}));
